import type { CommissionPayment } from "../api/commissionApi";

/**
 * Totales de la pantalla de referenciados.
 *
 * Viven acá y no dentro de la page porque son lógica pura y así se pueden probar sin
 * montar la vista.
 */

/**
 * Suma los montos de las comisiones.
 *
 * `amount` es opcional en el contrato, y no por imprecisión de springdoc: el DTO declara
 * `private Double amount`, un boxed nullable. Sumar un null daba NaN y la pantalla mostraba
 * "$NaN" en el total. Las filas sin monto se ignoran.
 */
export const sumCommissionAmounts = (payments: CommissionPayment[]): number =>
  payments.reduce((total, payment) => total + (payment.amount ?? 0), 0);

/** Cuenta referenciados distintos por email, ignorando los que no lo traen. */
export const countDistinctReferred = (payments: CommissionPayment[]): number =>
  new Set(payments.map((payment) => payment.candidateEmail).filter(Boolean)).size;
